"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var styles = __importStar(require("./Scholarship.module.css"));
var model_actions_creators_1 = require("./../../../store/model.actions.creators");
var ScholarshipPolicy_1 = require("./parts/ScholarshipPolicy");
var ScholarshipTerms_1 = require("./parts/ScholarshipTerms");
function mapStateToProps(_a) {
    var model = _a.model;
    return { json_data: model.json_data, errors: model.errors };
}
var mapDispatchToProps = {
    updateJonsCallback: model_actions_creators_1.updateJson
};
var Scholarship = (function (_super) {
    __extends(Scholarship, _super);
    function Scholarship(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            stateSelected: "CA"
        };
        _this.changeState = _this.changeState.bind(_this);
        return _this;
    }
    Scholarship.prototype.changeState = function (changeEvent) {
        this.setState({
            stateSelected: changeEvent.target.value
        });
    };
    Scholarship.prototype.render = function () {
        var isPdf = false;
        if (window.isPdf) {
            isPdf = true;
        }
        return (react_1.default.createElement("div", { id: "scholarship", className: styles.containerPosition + " " + styles.breakPage },
            !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone }),
            react_1.default.createElement("div", { className: "" + styles.pageSize },
                react_1.default.createElement(ScholarshipPolicy_1.AsherScholarshipPolicy, { nextForm: this.props.nextForm }),
                react_1.default.createElement(ScholarshipTerms_1.AsherScholarshipTerms, { nextStudentForm: this.props.nextStudentForm })),
            !isPdf && react_1.default.createElement("div", { className: "gray-line " + styles.displayNone })));
    };
    return Scholarship;
}(react_1.Component));
exports.Scholarship = Scholarship;
exports.ScholarshipContainer = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Scholarship);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Nob2xhcnNoaXBDb250YWluZXIuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9TY2hvbGFyc2hpcC9zY2hvbGFyc2hpcENvbnRhaW5lci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFzQztBQUN0QywyQ0FBbUM7QUFDbkMsK0RBQWtEO0FBRWxELGtGQUFrRTtBQUNsRSwrREFBZ0U7QUFDaEUsNkRBQThEO0FBRzlELFNBQVMsZUFBZSxDQUFDLEVBQU87UUFBTixnQkFBSztJQUMzQixPQUFPLEVBQUMsU0FBUyxFQUFFLEtBQUssQ0FBQyxTQUFTLEVBQUUsTUFBTSxFQUFFLEtBQUssQ0FBQyxNQUFNLEVBQUMsQ0FBQTtBQUM3RCxDQUFDO0FBRUQsSUFBTSxrQkFBa0IsR0FBRztJQUN2QixrQkFBa0IsRUFBRSxtQ0FBVTtDQUNqQyxDQUFBO0FBRUQ7SUFBaUMsK0JBQW1CO0lBQ2hELHFCQUFZLEtBQUs7UUFBakIsWUFDSSxrQkFBTSxLQUFLLENBQUMsU0FLZjtRQUpHLEtBQUksQ0FBQyxLQUFLLEdBQUc7WUFDVCxhQUFhLEVBQUUsSUFBSTtTQUN0QixDQUFBO1FBQ0QsS0FBSSxDQUFDLFdBQVcsR0FBRyxLQUFJLENBQUMsV0FBVyxDQUFDLElBQUksQ0FBQyxLQUFJLENBQUMsQ0FBQTs7SUFDbEQsQ0FBQztJQUVELGlDQUFXLEdBQVgsVUFBWSxXQUFXO1FBQ25CLElBQUksQ0FBQyxRQUFRLENBQUM7WUFDVixhQUFhLEVBQUUsV0FBVyxDQUFDLE1BQU0sQ0FBQyxLQUFLO1NBQzFDLENBQUMsQ0FBQTtJQUNOLENBQUM7SUFFRCw0QkFBTSxHQUFOO1FBQ0ksSUFBSSxLQUFLLEdBQUcsS0FBSyxDQUFBO1FBRWpCLElBQUksTUFBTSxDQUFDLEtBQUssRUFBRTtZQUNkLEtBQUssR0FBRyxJQUFJLENBQUE7U0FDZjtRQUVELE9BQU8sQ0FDSCx1Q0FBSyxFQUFFLEVBQUMsYUFBYSxFQUFDLFNBQVMsRUFBSyxNQUFNLENBQUMsaUJBQWlCLFNBQUksTUFBTSxDQUFDLFNBQVc7WUFDN0UsQ0FBQyxLQUFLLElBQUksdUNBQUssU0FBUyxFQUFFLGVBQWEsTUFBTSxDQUFDLFdBQWEsR0FBUTtZQUNwRSx1Q0FBSyxTQUFTLEVBQUUsS0FBRyxNQUFNLENBQUMsUUFBVTtnQkFNaEMsOEJBQUMsMENBQXNCLElBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxHQUFHO2dCQUN4RCw4QkFBQyx3Q0FBcUIsSUFBQyxlQUFlLEVBQUUsSUFBSSxDQUFDLEtBQUssQ0FBQyxlQUFlLEdBQUksQ0FFcEU7WUFDTCxDQUFDLEtBQUssSUFBSSx1Q0FBSyxTQUFTLEVBQUUsZUFBYSxNQUFNLENBQUMsV0FBYSxHQUFRLENBQ2xFLENBQ1QsQ0FBQTtJQUNMLENBQUM7SUFDTCxrQkFBQztBQUFELENBQUMsQUF2Q0QsQ0FBaUMsaUJBQVMsR0F1Q3pDO0FBdkNZLGtDQUFXO0FBd0NYLFFBQUEsb0JBQW9CLEdBQUcscUJBQU8sQ0FDdkMsZUFBZSxFQUNmLGtCQUFrQixDQUNyQixDQUFDLFdBQVcsQ0FBQyxDQUFBIn0=